"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsedPayload = void 0;
var qrcode_1 = require("qrcode");
var constants_1 = require("../lib/constants");
var GetFieldsConfig_1 = require("../utils/GetFieldsConfig");
var Iterator_1 = require("../utils/Iterator");
var ParsedPayload = /** @class */ (function () {
    function ParsedPayload(payload, fields) {
        this.raw = payload;
        this.fields = GetFieldsConfig_1.GetFieldsConfig(fields);
    }
    ParsedPayload.prototype.toIterator = function () {
        return Iterator_1.generateIterator(this.fields);
    };
    Object.defineProperty(ParsedPayload.prototype, Symbol.toStringTag, {
        get: function () {
            return 'ParsedPayload';
        },
        enumerable: false,
        configurable: true
    });
    ParsedPayload.prototype[Symbol.iterator] = function () {
        return this.toIterator();
    };
    ParsedPayload.prototype.toArray = function () {
        return this.fields;
    };
    ParsedPayload.prototype.toObject = function () {
        var e_1, _a;
        var fields = {};
        try {
            for (var _b = __values(this.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var field = _c.value;
                fields[field.id] = field;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return fields;
    };
    ParsedPayload.prototype.toString = function () {
        return this.raw;
    };
    ParsedPayload.prototype.toQRCode = function (type) {
        if (type === void 0) { type = 'dataURL'; }
        switch (type) {
            case 'dataURL':
                return qrcode_1.toDataURL(this.raw);
            case 'terminal':
                return qrcode_1.toString(this.raw, { type: 'terminal' });
            case 'svg':
                return qrcode_1.toString(this.raw, { type: 'svg' });
            case 'utf8':
                return qrcode_1.toString(this.raw, { type: 'utf8' });
            case 'buffer':
                return qrcode_1.toBuffer(this.raw);
        }
    };
    ParsedPayload.prototype.getField = function (id) {
        if (!Object.values(constants_1.IDS).includes(id)) {
            throw new Error("ParsedPayload: field " + id + " not found");
        }
        var field = this.fields.find(function (field) { return field.id === id; });
        if (!field) {
            throw new Error("ParsedPayload: field " + id + " not found");
        }
        return field;
    };
    ParsedPayload.prototype.getWithoutError = function (name) {
        try {
            return this[name];
        }
        catch (_a) {
            return undefined;
        }
    };
    Object.defineProperty(ParsedPayload.prototype, "merchantAccountField", {
        get: function () {
            var merchantAccount = this.getField(constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION);
            return merchantAccount.body;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "additionalDataField", {
        get: function () {
            var additionalData = this.getField(constants_1.IDS.ID_ADDITIONAL_DATA_FIELD_TEMPLATE);
            return additionalData.body;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "merchantAccount", {
        get: function () {
            return {
                gui: this.getWithoutError('gui'),
                key: this.getWithoutError('pixKey'),
                description: this.getWithoutError('description'),
                pss: this.getWithoutError('pss')
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "additionalData", {
        get: function () {
            return {
                txID: this.getWithoutError('txID')
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "pixKey", {
        get: function () {
            var pixKeyField = this.merchantAccountField.find(function (field) { return field.id === constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_KEY; });
            return pixKeyField.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "txID", {
        get: function () {
            var txIDField = this.additionalDataField.find(function (field) { return field.id === constants_1.IDS.ID_ADDITIONAL_DATA_FIELD_TEMPLATE_TXID; });
            return txIDField.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "identifier", {
        get: function () {
            return this.txID;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "country", {
        get: function () {
            return this.getField(constants_1.IDS.ID_COUNTRY_CODE).data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "CRC16", {
        get: function () {
            return this.getField(constants_1.IDS.ID_CRC16).data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "merchantCategoryCode", {
        get: function () {
            return this.getField(constants_1.IDS.ID_MERCHANT_CATEGORY_CODE).data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "merchantCity", {
        get: function () {
            return this.getField(constants_1.IDS.ID_MERCHANT_CITY).data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "merchantName", {
        get: function () {
            return this.getField(constants_1.IDS.ID_MERCHANT_NAME).data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "payloadFormat", {
        get: function () {
            return this.getField(constants_1.IDS.ID_PAYLOAD_FORMAT_INDICATOR).data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "transactionAmount", {
        get: function () {
            try {
                return this.getField(constants_1.IDS.ID_TRANSACTION_AMOUNT);
            }
            catch (error) {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "transactionCurrency", {
        get: function () {
            return this.getField(constants_1.IDS.ID_TRANSACTION_CURRENCY).data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "gui", {
        get: function () {
            var field = this.merchantAccountField.find(function (field) { return field.id === constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_GUI; });
            return field.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "description", {
        get: function () {
            var field = this.merchantAccountField.find(function (field) { return field.id === constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_DESCRIPTION; });
            if (!field) {
                throw new Error('ParsedPayload: description not found');
            }
            return field.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParsedPayload.prototype, "pss", {
        get: function () {
            var field = this.merchantAccountField.find(function (field) { return field.id === constants_1.IDS.ID_MERCHANT_ACCOUNT_INFORMATION_PSS; });
            if (!field) {
                throw new Error('ParsedPayload: pss not found');
            }
            return field.data;
        },
        enumerable: false,
        configurable: true
    });
    return ParsedPayload;
}());
exports.ParsedPayload = ParsedPayload;
